import { __, sprintf } from '@wordpress/i18n';

export default function ServicePointList({ servicePoints, onSelect, selectedServicePoint }) {
  return (
    <div className={'service_points_list'}>
      {servicePoints.map((servicePoint) => {
        return (
          <div
            key={servicePoint.id}
            className={
              'service_point' + (selectedServicePoint && selectedServicePoint.id === servicePoint.id ? ' selected' : '')
            }
            onClick={() => onSelect(servicePoint)}
          >
            <div className={'header'}>
              <span className={'name'}>{servicePoint.name}</span>
            </div>
            <div className={'location'}>
              <div className={'address_info'}>
                {sprintf(
                  // translators: %1$s: Address, %2$s: Zip Code, %3$s: City
                  __('%1$s, %2$s %3$s', 'shipmondo-for-woocommerce'),
                  servicePoint.address,
                  servicePoint.zipcode,
                  servicePoint.city
                )}
              </div>
              <div className={'distance'}>
                {parseFloat((servicePoint.distance / 1000).toFixed(2))} {__('km', 'shipmondo-for-woocommerce')}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
